/* istanbul ignore file */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import ReactGA from 'react-ga4';
import App from './App';
import { ga4MeasurementId } from './constants/config';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

ReactGA.initialize(ga4MeasurementId);

const router = createBrowserRouter([
  {
    path: '/*', // Matches all paths, letting <App> manage its own internal routes
    element: <App />,
  },
]);

const root = createRoot(document.getElementById('main'));

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider
        router={router}
        // NOTE: Enables React Router v7 experimental features:
        // v7_relativeSplatPath: Makes relative links inside * routes resolve correctly
        // v7_startTransition: Makes route updates smoother by avoiding render blocking
        future={{ v7_relativeSplatPath: true, v7_startTransition: true }}
      />
    </QueryClientProvider>
  </React.StrictMode>,
);
